<template>
  <l-modal :showing="showing" text="Edit converted timeserie" icon="edit" color="bg-orange-500" @close="close">
    <div class="w-full flex flex-col text-xs">      
      <div class="flex mb-4">        
        <div class="w-full mr-4">        
          <b>Timeserie</b><br>
          <l-select v-model="editObj.oc_id" class="text-xs" :data="timeseries" placeholder="Please select" :multiple="false" >
              <l-option v-for="i in timeseries" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
            </l-select>       
        </div>
        <div class="w-full mr-4">        
          <b>Source</b><br>
          <l-select v-model="editObj.source" class="text-xs" :data="units" placeholder="Please select" :multiple="false" >
              <l-option v-for="i in units" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
            </l-select>       
        </div>
        <div class="w-full mr-4">        
          <b>Target</b><br>
          <l-select v-model="editObj.target" class="text-xs" :data="units" placeholder="Please select" :multiple="false" >
            <l-option v-for="i in units" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
          </l-select>       
        </div>
        <div class="w-full">        
          <b>Factor</b><br>
          <l-input v-model="editObj.factor" />   
        </div>
      </div>
      
      <div class="flex w-full justify-between">
        <div>
          <l-button type="success" :disabled="!editObj.oc_id || !editObj.source || !editObj.target || !editObj.factor" @click="onSave">Save changes</l-button>&nbsp;
        </div>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton, LSelect, LOption } from "@/components/forms";
import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox"


export default {
  name: "LLEdit",
  props: [
    "showing",
    "stations",
    "timeserie",
    "units"
  ],
  components: {
    LModal,
    LInput,
    LButton,
    LSelect,
    LOption,
    LInfoBox
  },
  computed: {        
    editObj: function() {
      return Object.assign({}, this.timeserie);
    },
    timeseries() {
      const sel = this.stations.find(t => {
        return t.value == this.editObj.sta_id;
      });
      if (!sel) return [];
      
      return sel.timeseries;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSave() {
      this.$emit("save", this.editObj);
      this.close();
    },
  }
};
</script>